$shm_projects_goal_output $mol_page
	mode? \process
	process $shm_projects_goal_chat
	result null
	title_content /
		<= Modes $mol_view
			sub /
				<= Process $mol_link
					arg <= process_arg *
					current <= process_current false
					title \Процесс
					sub / \Процесс
					click? <=> process_select? null
				<= Result $mol_link
					arg <= result_arg *
					current <= result_current false
					title \Результат
					sub / \Результат
					click? <=> result_select? null
	body <= output_content /
